import actions from './actions';

const {
  GET_VEHICLE_BEGIN, GET_VEHICLE_SUCCESS, GET_VEHICLE_FAILED,
  GET_VEHICLES_SUCCESS, GET_VEHICLES_BEGIN, GET_VEHICLES_FAILED,
  ADD_VEHICLE_BEGIN, ADD_VEHICLE_SUCCESS, ADD_VEHICLE_FAILED,
  UPDATE_VEHICLE_BEGIN, UPDATE_VEHICLE_SUCCESS, UPDATE_VEHICLE_FAILED,
  DELETE_VEHICLE_BEGIN, DELETE_VEHICLE_SUCCESS, DELETE_VEHICLE_FAILED,
} = actions;

const initState = {
  total: 0,
  brands: [],
  status: '',
  featured: '',
  category: null,
  currentPage: 1,
  pageLimit: 9,
  vehicles: [],
  allVehicles: [],
  loading: false,
  error: null,
};

const VehicleReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_VEHICLE_BEGIN:
      return {
        ...state,
        total: 0,
        vehicles: [],
        loading: true,
      };
    case GET_VEHICLE_SUCCESS:
      return {
        ...state,
        total: data.total,
        vehicles: data.vehicles,
        currentPage: data.currentPage || state.currentPage,
        pageLimit: data.pageLimit || state.pageLimit,
        brands: data.brands || [],
        status: data.status || null,
        featured: data.featured || '',
        category: data.category || null,
        loading: false,
      };
    case GET_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_VEHICLES_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_VEHICLES_SUCCESS:
      return {
        ...state,
        allVehicles: data,
        loading: false,
      };
    case GET_VEHICLES_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_VEHICLE_SUCCESS:
      return {
        ...state,
        total: state.total + 1,
        vehicles: data,
        loading: false,
      };
    case ADD_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicles: data,
        loading: false,
      };
    case UPDATE_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_VEHICLE_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        vehicles: data,
        loading: false,
      };
    case DELETE_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default VehicleReducer;